import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import * as OrderUtils from "@omni/utils/order.utils";
import { useMemo } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { getProductConfigurationPreview } from "@/utils/productConfiguration";
import {
    getProductConfiguration,
    productConfigurations
} from "@/utils/productConfiguration/productConfiguration.utils";

type HeaderComponentProps = {
    item: OrderItem;
    link?: boolean;
};

const getConfiguration = (item: OrderItem) => {
    const productConfiguration = getProductConfiguration({ sku: item.sku });

    return getProductConfigurationPreview(
        OrderUtils.getConfiguration(item, productConfigurations),
        productConfiguration
    );
};

const HeaderComponent = ({ item, link }: HeaderComponentProps) => {
    const { t } = useGranite();
    const productConfiguration = useMemo(() => getConfiguration(item), [item]);

    const headerTitle = `${OrderUtils.getTitle(item, t)} ${productConfiguration}`;

    const itemUrl = OrderUtils.getUrl(item, Config.pages.giftcard);

    return itemUrl && link ? (
        <a
            className={"d-block"}
            href={itemUrl}
        >
            {headerTitle}
        </a>
    ) : (
        <span className={"h4 font-weight-normal m-0 pb-2 d-block"}>
            {headerTitle}
        </span>
    );
};

export { HeaderComponent };
